import { Grid } from '@factorialco/deprecated-design-system'
import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import Coefficient from './Coefficient'
import Echelon from './Echelon'
import EmployeeType from './EmployeeType'
import ForfaitJours from './ForfaitJours'
import JoursParAn from './JoursParAn'
import Mutuelle from './Mutuelle'
import Niveau from './Niveau'
import ProfessionalCategory from './ProfessionalCategory'

interface Props {
  contractVersion: ContractVersionPageContractVersionFragment
}

const France = ({ contractVersion }: Props) => {
  const canEdit = contractVersion._policies?.edit?.can ?? false
  const coefficient = contractVersion.frCoefficient
  const professionalCategory = contractVersion.franceProfessionalCategory?.name
  const employeeType = contractVersion.frEmployeeType
  const niveau = contractVersion.franceLevel?.name
  const echelon = contractVersion.franceStep?.name
  const hasForfaitYours = !!contractVersion.frForfaitJours
  const joursParAn = hasForfaitYours ? contractVersion.frJoursParAn : null
  const mutuelle = contractVersion.franceMutual?.name

  const showCoefficient = !!coefficient || canEdit
  const showProfessionalCategory = !!professionalCategory || canEdit
  const showEmployeeType = !!employeeType || canEdit
  const showNiveau = !!niveau || canEdit
  const showEchelon = !!echelon || canEdit
  const showJoursParAn = (hasForfaitYours && !!joursParAn) || canEdit
  const showMutuelle = !!mutuelle || canEdit

  return (
    <Grid variant="fixed">
      {showCoefficient && <Coefficient coefficient={coefficient ?? undefined} />}
      {showProfessionalCategory && (
        <ProfessionalCategory professionalCategory={professionalCategory} />
      )}
      {showEmployeeType && <EmployeeType employeeType={employeeType ?? ''} />}
      {showNiveau && <Niveau niveau={niveau} />}
      {showEchelon && <Echelon echelon={echelon} />}
      <ForfaitJours hasForfaitJours={hasForfaitYours} />
      {showJoursParAn && <JoursParAn jours={joursParAn ?? undefined} />}
      {showMutuelle && <Mutuelle mutuelle={mutuelle} />}
    </Grid>
  )
}

export default France
